const inp = "w-full rounded-2xl border border-[#CFC8BC] bg-white px-5 py-3.5 text-base outline-none transition-colors focus:border-[#111]";
const Campo = ({ k, l, r, set, ph, type = "text" }) => (
  <label className="block text-xs font-semibold uppercase tracking-wider text-[#5C5850]">{l}
    <input type={type} className={`${inp} mt-1.5 normal-case tracking-normal text-[#111]`} value={r[k] || ""} placeholder={ph} onChange={(e) => set({ [k]: e.target.value })} data-testid={`alta-in-${k}`} />
  </label>
);

export const PasoDatos = ({ r, set }) => (
  <div data-testid="alta-datos">
    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#E8643C]">Programa de Referenciadores</p>
    <h1 className="mt-3 font-serif-display text-4xl font-bold leading-tight sm:text-5xl">Tus datos</h1>
    <p className="mt-3 text-sm text-[#5C5850]">Cuatro pasos desde tu celular: datos, INE, convenio y firma.</p>
    <div className="mt-7 grid grid-cols-2 gap-2">
      {[["PF", "Persona física"], ["PM", "Persona moral"]].map(([v, l]) => (
        <button key={v} type="button" onClick={() => set({ tipo: v })} data-testid={`alta-tipo-${v}`}
          className={`rounded-2xl border px-4 py-3.5 text-sm font-semibold transition-colors ${r.tipo === v ? "border-[#111] bg-[#111] text-white" : "border-[#CFC8BC] bg-white hover:border-[#111]"}`}>{l}</button>))}
    </div>
    <div className="mt-5 space-y-4">
      <Campo k="nombre" l={r.tipo === "PM" ? "Razón social" : "Nombre completo"} r={r} set={set} />
      <Campo k="rfc" l="RFC con homoclave" r={r} set={set} ph={r.tipo === "PM" ? "AAA000000XXX" : "AAAA000000XXX"} />
      {r.tipo === "PM" && <div className="grid gap-4 sm:grid-cols-2"><Campo k="rep" l="Representante legal" r={r} set={set} /><Campo k="rep_cargo" l="Cargo" r={r} set={set} ph="Director General" /></div>}
      <Campo k="email" l="Correo electrónico" r={r} set={set} type="email" />
      <Campo k="celular" l="Celular (10 dígitos)" r={r} set={set} type="tel" ph="55 1234 5678" />
      <input className="hidden" tabIndex={-1} autoComplete="off" value={r.website || ""} onChange={(e) => set({ website: e.target.value })} aria-hidden />
    </div>
    <p className="mt-5 text-xs text-[#8C867A]">Al continuar, Trafalgar trata tus datos conforme a su aviso de privacidad (LFPDPPP), incluido en tu convenio.</p>
  </div>
);
